/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcLaptopIcon20Light = forwardRef('TechPcLaptopIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z" }),
        React.createElement("path", { d: "M3.421 14.823a.5.5 0 0 0-.763-.646L1.512 15.53C.687 16.506 1.379 18 2.657 18h14.686c1.277 0 1.97-1.494 1.145-2.47l-1.146-1.353a.5.5 0 0 0-.763.646l1.146 1.354a.5.5 0 0 1-.382.823H2.657a.5.5 0 0 1-.382-.823l1.146-1.354Z" })));
});
